import { Injectable, Injector } from '@angular/core';
import { StateContext, Guid, ImageMessage } from '@lcu/common';
import { LocationsState } from './locations-state.model';
import { MapMarker, UserMap } from '@lowcodeunit/lcu-map-common';
import { ItineraryModel } from '../../models/itinerary.model';
import { UserAlbum } from '../../models/user-album.model';
import { UserPhoto } from '../../models/user-photo.model';
import { TopListModel } from '../../models/top-list.model';
import { UserInfo } from '../../models/user-info.model';
import { ActivityModel } from '@lowcodeunit/lcu-map-common/lib/models/activity.model';

@Injectable({
  providedIn: 'root',
})
export class LocationsStateContext extends StateContext<LocationsState> {
  //  Fields
  protected state: LocationsState;

  //  Properties

  //  Constructors
  constructor(protected injector: Injector) {
    super(injector);
  }

  //  API Methods

  public ChangeExcludedCurations(UsersExcludedLocations: string) {
    console.log('hiding locations with Ids: ', UsersExcludedLocations);

    this.Execute({
      Arguments: {
        LocationIDs: UsersExcludedLocations,
      },
      Type: 'ChangeExcludedCurations',
    });
  }

  public EditLocation(marker: MapMarker) {
    console.log('editing: ', marker);

    this.Execute({
      Arguments: {
        Location: marker,
      },
      Type: 'EditLocation',
    });
  }

  public AddLocation(marker: MapMarker) {
    console.log('adding location: ', marker);

    this.Execute({
      Arguments: {
        Location: marker,
      },
      Type: 'AddLocation',
    });
  }

  public DeleteLocation(marker: MapMarker) {
    console.log('deleting: ', marker);

    this.Execute({
      Arguments: {
        LocationID: marker.ID,
      },
      Type: 'DeleteLocation',
    });
  }

  //  Helpers
  protected defaultValue() {
    return { Loading: true } as LocationsState;
  }

  protected loadStateKey(): string {
    return 'locations';
  }

  protected loadStateName(): string {
    return 'amblon';
  }

  protected setupReceiveState(groupName: string) {
    this.rt.RegisterHandler(`ReceiveState=>${groupName}`).subscribe((req) => {
      console.log(`Handled state from ${groupName}`);
 
      this.subject.next(req);
    });
  }
}
